"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = exports.Tracker = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _excluded = ["event"];
var _nest = function nest(obj, key, value) {
  var _Object$assign2;
  if (obj === void 0) {
    obj = {};
  }
  var keys = key.split('.');
  if (keys.length > 1) {
    var _Object$assign;
    return Object.assign({}, obj, (_Object$assign = {}, _Object$assign[keys[0]] = _nest(obj[keys[0]], keys.slice(1).join('.'), value), _Object$assign));
  }
  return Object.assign({}, obj, (_Object$assign2 = {}, _Object$assign2[key] = value, _Object$assign2));
};
var Tracker = exports.Tracker = /*#__PURE__*/function () {
  function Tracker() {
    this.state = {};
    this.listeners = new Set();
  }
  var _proto = Tracker.prototype;
  _proto.emit = function emit(event) {
    var _this = this;
    this.listeners.forEach(function (listener) {
      return listener(event, _this.state);
    });
  };
  _proto.addListener = function addListener(listener) {
    this.listeners.add(listener);
  };
  _proto.removeListener = function removeListener(listener) {
    this.listeners.delete(listener);
  };
  _proto.push = function push(data) {
    var event = data.event,
      rest = (0, _objectWithoutPropertiesLoose2.default)(data, _excluded);
    this.state = Object.entries(rest).reduce(function (acc, _ref) {
      var key = _ref[0],
        value = _ref[1];
      return _nest(acc, key, value);
    }, this.state);
    if (event) {
      this.emit(event);
    }
  };
  return Tracker;
}();
var _default = exports.default = new Tracker();